'use strict';

var react = require('react');

const FormContext = react.createContext(undefined);
const FormContextProvider = FormContext.Provider;
const useFormContext = () => react.useContext(FormContext);

exports.FormContextProvider = FormContextProvider;
exports.useFormContext = useFormContext;
//# sourceMappingURL=FormContext.js.map
